export enum TourType {
  SEA_TOUR = "Туры",
  ROUTE = "Проезд",
  EXCURSION = "Экскурсионные туры ",
  HOTEL = "Отели",
  CATALOG_HOTEL_WITH_DIRECTION = "Отели, Проезд",
  CATALOG_HOTEL_WITHOUT_DIRECTION = "Отели, Без проезда",
  CATALOG_EXCURSION = "Каталог - Экскурсионные туры",
}
